export interface Article {
  id: number;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  date: string;
  image: string;
  tags: string[];
  readCount: number;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2026年暑期档票房突破200亿，国产电影强势崛起',
    summary: '今年暑期档电影市场异常火爆，国产影片凭借精良制作和深刻主题赢得观众青睐，票房一路高歌猛进。',
    content: `<p>2026年暑期档中国电影市场迎来了历史性的突破。据国家电影局最新数据显示，截至8月1日，暑期档总票房已突破200亿元人民币，较去年同期增长35%。</p>
    <p>其中，国产影片表现尤为亮眼。《星际迷途：重生》以38亿票房领跑暑期档，紧随其后的是《烈火战将》31亿和《暗夜追踪》25亿。三部国产大片占据了票房前三甲。</p>
    <p>业内专家分析认为，今年暑期档的成功得益于多方面因素：一是国产电影制作水平的显著提升，特效技术已与国际接轨；二是影片题材更加多元化，涵盖了科幻、动作、悬疑、喜剧等多种类型；三是观众审美水平的提高，更愿意为优质内容买单。</p>
    <p>"中国电影正在经历一个黄金时代。"著名导演郭帆在接受采访时表示，"观众对国产电影的信任度越来越高，这对整个行业来说是最好的激励。"</p>
    <p>暑期档还在继续，多部重量级影片蓄势待发。业内人士预计，今年全年票房有望突破800亿大关，创历史新高。</p>`,
    category: '行业动态',
    author: '影视观察员',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20box%20office%20record%20celebration%2C%20movie%20theater%20with%20crowded%20audience%2C%20bright%20lights%2C%20red%20carpet%20premiere%20atmosphere%2C%20festive%20golden%20and%20red%20tones%2C%20grand%20cinematic%20scale&width=1200&height=600&seq=article-001&orientation=landscape',
    tags: ['暑期档', '票房', '国产电影'],
    readCount: 15280,
  },
  {
    id: 2,
    title: '《长安十二时辰之终极对决》开播即爆，口碑收视双丰收',
    summary: '备受期待的《长安十二时辰》续作正式开播，延续前作的高水准制作，首播收视率破3，引发全网热议。',
    content: `<p>由曹盾执导，雷佳音、易烊千玺领衔主演的古装悬疑巨制《长安十二时辰之终极对决》于昨晚正式开播。该剧首播两集即在多个平台取得收视冠军，全网话题阅读量突破20亿。</p>
    <p>作为《长安十二时辰》的续作，该剧延续了前作精良的制作水准和紧凑的叙事节奏。剧组耗时两年打造，在服化道、场景搭建等方面投入巨大，力求还原大唐盛世的恢弘气魄。</p>
    <p>"我们不想辜负观众的期待。"导演曹盾在首映发布会上表示，"这部续作在保持原有风格的基础上，加入了更多悬疑元素和动作场面，故事更加扣人心弦。"</p>
    <p>豆瓣开分9.3分，超过90%的观众给出了五星好评。网友纷纷评论："每一帧都是壁纸"、"剧情环环相扣根本停不下来"、"易烊千玺演技又进步了"。该剧无疑是今年最值得追的国产剧之一。</p>`,
    category: '新剧推荐',
    author: '追剧小达人',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20drama%20premiere%20red%20carpet%20event%2C%20actors%20in%20traditional%20costumes%2C%20palace%20architecture%20background%2C%20warm%20golden%20lighting%2C%20grand%20atmosphere&width=1200&height=600&seq=article-002&orientation=landscape',
    tags: ['长安十二时辰', '古装剧', '雷佳音'],
    readCount: 28350,
  },
  {
    id: 3,
    title: '吴京新片《末日崩塌：天火》曝光首支预告，特效震撼',
    summary: '吴京自导自演的科幻灾难大片发布首支预告片，震撼的视觉效果引发影迷热烈期待，被誉为中国版《2012》。',
    content: `<p>今日，由吴京自导自演的科幻灾难巨制《末日崩塌：天火》发布了首支正式预告片。这支时长两分钟的预告展现了陨石撞击地球的灾难场景，视觉效果令人震撼。</p>
    <p>据悉，该片投资超过10亿元人民币，聘请了好莱坞顶级特效团队参与制作。影片讲述了人类面对陨石袭击，全球科学家联手展开"天火计划"的故事。</p>
    <p>"这是我导演生涯中最具挑战的一部作品。"吴京在社交媒体上写道，"我们想证明，中国电影人也能拍出世界级的灾难大片。"</p>
    <p>预告片发布后迅速登上热搜，24小时内播放量突破5000万。网友纷纷表示期待："这特效已经比肩好莱坞了"、"吴京出品，必属精品"。影片定档2026年国庆档上映。</p>`,
    category: '新片速递',
    author: '电影发烧友',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20disaster%20movie%20press%20conference%20with%20director%20Wu%20Jing%20on%20stage%2C%20large%20screen%20showing%20meteor%20approaching%20earth%2C%20dramatic%20lighting%2C%20cinema%20event%20atmosphere&width=1200&height=600&seq=article-003&orientation=landscape',
    tags: ['吴京', '灾难片', '预告片'],
    readCount: 42100,
  },
  {
    id: 4,
    title: '国产动画电影崛起之路：从《大圣归来》到《海底总动员：新冒险》',
    summary: '十年间，中国动画电影从低谷走向繁荣，一部部优秀作品见证了整个行业的成长与蜕变。',
    content: `<p>十年前的《大圣归来》被认为是国产动画电影的转折点。在此之前，中国动画长期处于低谷，制作粗糙、故事幼稚是普遍问题。而《大圣归来》以9.56亿票房证明了中国动画的潜力。</p>
    <p>此后，《大鱼海棠》、《哪吒之魔童降世》、《姜子牙》等一系列佳作相继问世，不断刷新票房纪录。今年暑期档的《海底总动员：新冒险》延续了这一势头，目前票房已突破15亿。</p>
    <p>国产动画的成功离不开技术进步和人才积累。越来越多的动画工作室在建模、渲染、动作捕捉等方面达到了国际水准。同时，扎根中国传统文化的原创故事也赢得了观众的共鸣。</p>
    <p>"中国动画正在经历最好的时代。"资深动画制作人田晓鹏表示，"我们有信心在未来做出更多世界级的作品。"</p>`,
    category: '行业深度',
    author: '影视观察员',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20computers%2C%20colorful%20character%20designs%20on%20walls%2C%20creative%20workspace%2C%20warm%20lighting%2C%20modern%20office&width=1200&height=600&seq=article-004&orientation=landscape',
    tags: ['国产动画', '行业分析', '电影产业'],
    readCount: 9870,
  },
  {
    id: 5,
    title: '经典港片修复重映，《笑傲江湖》系列再度引发武侠热潮',
    summary: '多部经典香港武侠电影经过4K修复后重新上映，让新一代观众也能在大银幕上感受武侠世界的魅力。',
    content: `<p>近日，由香港电影资料馆主导的"经典武侠电影修复计划"正式启动。首批修复完成的影片包括《笑傲江湖》、《东方不败》、《新龙门客栈》等经典之作，将在全国院线重新上映。</p>
    <p>修复团队采用了最新的AI修复技术，在保留原片质感和风格的基础上，对画面、色彩、音效进行了全面提升。4K分辨率的清晰画面让这些经典影片焕发出新的生命力。</p>
    <p>"武侠电影是中国独有的电影类型，承载了几代人的记忆。"项目负责人表示，"通过修复重映，我们希望让更多年轻人了解这一文化瑰宝。"</p>
    <p>重映消息一出，影迷反响热烈。许多年轻人表示从未在大银幕看过这些经典，非常期待。一些老影迷则感慨："终于可以在电影院里重温青春了。"</p>`,
    category: '经典回顾',
    author: '电影发烧友',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20wuxia%20film%20restoration%20process%2C%20film%20reels%20and%20digital%20equipment%2C%20vintage%20movie%20posters%20on%20wall%2C%20warm%20nostalgic%20lighting%2C%20professional%20studio&width=1200&height=600&seq=article-005&orientation=landscape',
    tags: ['港片', '武侠', '修复重映'],
    readCount: 12560,
  },
  {
    id: 6,
    title: '短视频时代，电影如何吸引观众走进影院？',
    summary: '在短视频和流媒体平台日益普及的今天，传统电影院面临着前所未有的挑战和机遇。',
    content: `<p>随着抖音、快手等短视频平台的兴起，人们的注意力越来越碎片化。一部两小时的电影，在很多人看来已经是"奢侈"的娱乐消费。加上各大流媒体平台的竞争，电影院面临的压力前所未有。</p>
    <p>然而，数据告诉我们一个不同的故事。2025年中国电影总票房突破700亿元，同比增长15%。2026年暑期档更是创下了200亿的历史纪录。这说明，观众并没有抛弃电影院。</p>
    <p>"电影院提供的沉浸式体验是无法被替代的。"影院经营者表示，"关键在于电影本身的质量。"事实上，真正优秀的影片依然能够吸引大量观众走进影院。</p>
    <p>业内普遍认为，短视频和电影并非零和竞争关系。很多电影通过短视频平台进行营销和宣发，反而扩大了影响力。重要的是找到平衡点，让不同媒介形式各得其所。</p>`,
    category: '行业深度',
    author: '影视观察员',
    date: '2026-07-10',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20lobby%20with%20people%20buying%20tickets%20and%20popcorn%2C%20digital%20screens%20showing%20movie%20schedules%2C%20warm%20ambient%20lighting%2C%20busy%20atmosphere&width=1200&height=600&seq=article-006&orientation=landscape',
    tags: ['电影院', '短视频', '行业趋势'],
    readCount: 7650,
  },
];

export const getArticleById = (id: number): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getLatestArticles = (): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 4);
};